import { useDispatch } from "react-redux";
import { actionCloseModal, actionShowModal, actionShowToast, actionShowToastMobile } from "../redux/actions";

export const useModal = () => {
  const dispatch = useDispatch();

  const dispatchShowModal = (modalContent, options) => {
    dispatch(actionShowModal(modalContent, options));
  };

  const dispatchCloseModal = () => {
    dispatch(actionCloseModal());
  };

  const dispatchShowToast = (title, color) => {
    // console.log('dispatchShowToast', title, color);
    dispatch(actionShowToast(title, color));
  };
  const dispatchShowToastMobile = (title, color) => {
    // console.log('dispatchShowToastMobile');
    dispatch(actionShowToastMobile(title, color));
  };

  return {
    dispatchShowModal,
    dispatchCloseModal,
    dispatchShowToast,
    dispatchShowToastMobile,
  };
};